import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedEyeOff = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="hide" size="100%" color={stroke ?? color} />
);

export { LineRoundedEyeOff };
